<div class="row">
  <div class="col-12">
    <ziro-select [fieldId]="'webexCallingLicense'"></ziro-select>
  </div>
</div>

<div [hidden]="!formData || !formData.webexCallingLicense || formData.webexCallingLicense === UCM_LICENSE_NAME">
  <div class="row">
    <div [class]="!selectedDidOptions.length ? 'col-12' : 'col-6'">
      <div
        [ngClass]="{ 'has-feedback ziro-forms-error': isSubmitted && !selectedDialPlanGroup }"
        data-automation="webex-did-selector-dial-plan-group-wrapper"
      >
        <ziro-select [fieldId]="'location'"></ziro-select>
        @if (!enableWebexPerSite()) {
          <label for="dialPlanGroupSelect" class="mb-2">
            <span class="text-danger">*</span>
            {{ 'tkey;helpdesk.webex_calling.location_name.label.text' | translate }}
          </label>
          <ng-select
            id="dialPlanGroupSelect"
            [labelForId]="'dialPlanGroupSelect'"
            data-automation="webex-dial-plan-group-select"
            [items]="dialPlanGroups()"
            bindLabel="groupName"
            [(ngModel)]="selectedDialPlanGroup"
            (ngModelChange)="onDialPlanGroupChange()"
            [disabled]="isSubmitting"
            [clearable]="false"
          ></ng-select>
        }
      </div>
    </div>
    <div
      [hidden]="!selectedDialPlanGroup || !selectedDidOptions.length"
      data-automation="webex-did-filter-toggle-wrapper"
      [ngClass]="'col-6 '"
    >
      <div class="card">
        <div class="card-header">
          <div class="form-check" data-automation="webex-did-show-recently-deleted">
            <input
              type="checkbox"
              class="form-check-input"
              id="did-show-recently-deleted"
              data-automation="webex-did-show-recently-deleted-input"
              [(ngModel)]="showRecentlyDeleted"
              (ngModelChange)="applyComponentConfig()"
              [disabled]="isSubmitting"
            />
            <label
              class="form-check-label"
              [attr.data-automation]="'did-show-recently-deleted-label'"
              for="did-show-recently-deleted"
            >
              <i [ngClass]="ziroIcons.HISTORY"></i>
              {{ 'tkey;dndidselection.dndid.show_recently_deleted.label' | translate }}
            </label>
          </div>
          <div class="form-check" data-automation="webex-did-show-unavailable">
            <input
              type="checkbox"
              class="form-check-input"
              id="did-show-unavailable"
              data-automation="webex-did-show-unavailable-input"
              [(ngModel)]="showUnavailable"
              (ngModelChange)="applyComponentConfig()"
              [disabled]="isSubmitting"
            />
            <label
              class="form-check-label"
              [attr.data-automation]="'did-show-unavailable-label'"
              for="did-show-unavailable"
            >
              <i [ngClass]="ziroIcons.UNAVAILABLE + ' text-danger'"></i>
              {{ 'tkey;dndidselection.dndid.show_unavailable.label' | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ziro-loading-block [hidden]="!(selectedDialPlanGroup && isSearching)"></ziro-loading-block>

  <div [hidden]="!selectedDialPlanGroup" class="row">
    <div [hidden]="!selectedDidOptions.length" class="col-12">
      <ziro-extension-selector [fieldId]="'did'" [isSubmitting]="isSubmitting"></ziro-extension-selector>
    </div>
  </div>
</div>
